import * as _ from "lodash";

import { memoize } from "@ctra/utils";

import { TableData } from "../typings";
import { Base } from "./Base";

/**
 * X axis data type month class
 */
class Month extends Base {
  /**
   * Format xAxis data
   * @note formatting should happen in the chart rendering library
   * @param {T} value
   * @returns {T}
   */
  @memoize
  formatXAxis<T extends number | string>(value: T): T {
    return value;
  }

  /**
   * Format table data
   * @param {TableData["data"]} data
   * @returns {TableData["data"]}
   */
  @memoize
  formatTableData(data: TableData["data"]): TableData["data"] {
    // @ts-expect-error
    return _.sortBy(data, (item) => new Date(item.key).valueOf());
  }
}

export { Month };
